<script lang="ts">
  const {
    children,
    size = "m",
  }: { size?: "s" | "m"; children: () => any } = $props();
</script>
<p class:text-[14px]={size === "s"} class:text-[16px]={size === "m"}>
  {@render children()}
</p>
